export const baseUrl =process.env.NODE_ENV === 'production' ? '/sunbackend' : '/api/sunbackend';


// WEBPACK FOOTER //
// ./src/assets/url.js